import { useDashboardModel } from '../../../modelos/Dashboard/modeloDashboard';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowRight, Clock, MessageCircle } from 'lucide-react';

const RevisionTutor = ({ nombreEmpresa, nombreTutor }) => {
  const navigate = useNavigate();
  const {
    cargarServiciosRevision,
    serviciosPorRevisar,
    LoadingserviciosPorRevisar,
    errorserviciosPorRevisar,
  } = useDashboardModel();

  useEffect(() => {
    if (nombreEmpresa && nombreTutor) {
      cargarServiciosRevision(nombreEmpresa, nombreTutor);
    }
  }, [nombreEmpresa, nombreTutor]);

  // Si está cargando o no hay revisiones, no ocupamos espacio en el dashboard
  if (LoadingserviciosPorRevisar || serviciosPorRevisar.length === 0) return null;

  return (
    <div className="mb-8 overflow-hidden rounded-2xl border-2 border-red-100 bg-red-50 shadow-lg animate-in fade-in slide-in-from-top-4 duration-500">
      {/* HEADER DEL WIDGET */}
      <div className="flex items-center justify-between border-b border-red-100 bg-red-100/50 px-6 py-4">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-500 shadow-lg shadow-red-200">
            <AlertTriangle size={24} className="text-white animate-bounce" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="rounded bg-red-600 px-2.5 py-0.5 text-[10px] font-black uppercase tracking-tighter text-white shadow-sm">
                URGENTE
              </span>
              <h2 className="text-base font-black uppercase tracking-tight text-red-900">
                Revisiones Pendientes de Respuesta
              </h2>
            </div>
            <p className="text-[10px] font-bold uppercase tracking-widest text-red-700/70 mt-0.5">
              Atención requerida para cumplir con los estándares de calidad
            </p>
          </div>
        </div>
        
        <div className="hidden sm:flex flex-col items-end">
            <span className="text-xs font-black text-red-700 bg-white/60 px-4 py-1.5 rounded-full border border-red-200 shadow-sm">
                {serviciosPorRevisar.length} {serviciosPorRevisar.length === 1 ? 'CASO' : 'CASOS ACTIVOS'}
            </span>
        </div>
      </div>

      {/* LISTADO DE REVISIONES */}
      <div className="max-h-[300px] overflow-y-auto p-5 custom-scrollbar">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {serviciosPorRevisar.map((servicio) => (
            <div 
              key={servicio.codigo}
              className="group flex flex-col rounded-xl border border-red-200 bg-white p-4 transition-all hover:border-red-400 hover:shadow-md relative overflow-hidden"
            >
              {/* Indicador de urgencia lateral */}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-500 opacity-40 group-hover:opacity-100 transition-opacity"></div>

              <div className="flex justify-between items-start mb-3">
                <div className="flex flex-col">
                    <span className="text-[9px] font-black text-slate-400 uppercase leading-none mb-1">Código de Servicio</span>
                    <span className="font-mono text-sm font-bold text-slate-800">
                        {servicio.codigo}
                    </span>
                </div>
                <div className="flex items-center gap-1.5 px-2 py-1 bg-orange-50 text-orange-600 rounded-md border border-orange-100">
                    <Clock size={12} />
                    <span className="text-[10px] font-black uppercase">Pendiente</span>
                </div>
              </div>
              
              <div className="mb-4 bg-slate-50 p-2.5 rounded-lg border border-slate-100">
                <p className="text-[9px] font-black uppercase text-slate-400 mb-1">Motivo del Reporte</p>
                <p className="text-xs font-bold text-slate-600 truncate capitalize">
                  {servicio.revision?.motivo || 'Revisión técnica general'}
                </p>
              </div>

              <button
                onClick={() => {
                    const nombreEmpresaURL = servicio.nombreEmpresa.replace(/ /g, '_');
                    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
                }}
                className="mt-auto flex items-center justify-center gap-2 rounded-xl bg-slate-900 py-3 text-[10px] font-black uppercase text-white transition-all hover:bg-red-600 hover:shadow-lg active:scale-95 tracking-widest"
              >
                <span>Responder a la Revisión</span>
                <ArrowRight size={14} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER PEQUEÑO */}
      <div className="bg-red-100/30 px-6 py-2 border-t border-red-100">
          <p className="text-[9px] text-red-700/50 font-bold uppercase text-center tracking-tighter">
            Recuerda que el tiempo de respuesta afecta tu calificación como tutor
          </p>
      </div>
    </div>
  );
};

export default RevisionTutor
